export default {
    actions: {
        storeCV(ctx, data) {
            return new Promise((resolve, reject) => {
                axios

                    .post(data.path + '/resumes', data.cv, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(() => {
                        resolve()
                    }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}
